// @flow

const XS = 400;
const SM = 576;
const MD = 768;
const LG = 992;
const XL = 1260;

export const isXsDown = (width: number) => XS < width;
export const isSmDown = (width: number) => SM < width;
export const isMdDown = (width: number) => MD < width;
export const isLgDown = (width: number) => LG < width;
export const isXlDown = (width: number) => XL < width;

export const isXsUp = (width: number) => XS > width;
export const isSmUp = (width: number) => SM > width;
export const isMdUp = (width: number) => MD > width;
export const isLgUp = (width: number) => LG > width;
export const isXlUp = (width: number) => XL > width;

export const isXs = (width: number) => XS === width;
export const isSm = (width: number) => SM === width;
export const isMd = (width: number) => MD === width;
export const isLg = (width: number) => LG === width;
export const isXl = (width: number) => XL === width;
